module.exports = __webpack_public_path__ + "media/images/avatar_female3-c74e9ff25b2d8a1a97e9199634773ebd.png";